import React, { memo } from 'react'

interface IInlineRowProps {
  rowTitle?: JSX.Element | string
  rowBody?: any
  bodyClass?: string
  containerClass?: string
}

export const InlineRow = memo<IInlineRowProps>(
  ({ bodyClass = '', containerClass = 'load-details-row', rowBody, rowTitle }) => {
    return (
      <div className='row'>
        <div className={`${containerClass} mt2`}>
          <div className='col-md-3 col-lg-3 col-xs-12'>
            <div className='text-secondary inline-row-title'>{rowTitle}</div>
          </div>
          <div className={`col-md-9 col-lg-9 col-xs-12 ${bodyClass}`}>{rowBody}</div>
        </div>
      </div>
    )
  }
)
